import { useTranslation } from 'react-i18next';

import { CustomModal } from 'components/shared';
import { CustomModalProps } from 'components/shared/CustomModal/CustomModal';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { OrderDetailsDTO } from 'interfaces';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './DeliverOrderModal.module.css';

type DeliverOrderModalProps = CustomModalProps & {
   selectedOrderId: string;
   onSuccessDeliverOrder: (updatedOrder: OrderDetailsDTO) => void;
};

const DeliverOrderModal = ({
   selectedOrderId,
   onSuccessDeliverOrder,
   onClose,
   ...props
}: DeliverOrderModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });
   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const handleDeliverOrder = () => {
      setIsLoading(true);
      HTTPService.changeOrderStatus(selectedOrderId, 'DELIVER')
         .then(response => {
            closeModalHandler();
            onSuccessDeliverOrder(response.data);
         })
         .catch(error => {
            setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            logNetworkError(error);
         })
         .finally(() => setIsLoading(false));
   };

   return (
      <CustomModal
         {...props}
         onClose={closeModalHandler}
         innerTitle={t('order_details_page.mark_as_delivered')}
         icon="ALERT_TRIANGLE"
         primaryButtonProps={{
            text: t('order_details_page.mark_as_delivered'),
            variant: 'filled-primary',
            onClick: handleDeliverOrder,
         }}
         secondaryButtonProps={{
            text: t('common.cancel'),
            variant: 'outlined-primary',
            onClick: closeModalHandler,
         }}
         isLoading={isLoading}
         error={errorInfo}
         modalContentClassName={styles.modalContent}
      >
         <div className={styles.descriptionContainer}>
            <p className={styles.plainText}>{t('deliver_order_modal.confirmation')}</p>
            <p className={styles.boldBlackText}>{t('cancel_pallet_report_modal.irreversible')}</p>
         </div>
      </CustomModal>
   );
};

export default DeliverOrderModal;
